import React from "react";

import TodayOutlinedIcon from "@mui/icons-material/TodayOutlined";
import { Box, Typography } from "@mui/material";
import { SelectDateRange } from "components/forms";
import { NumberFormat } from "components/reports/Number-format/NumberFormat";
import { SelectCurrency } from "components/reports/Select-currency/SelectCurrency";
import type { DateRangeValue, Filters } from "store/types";

import { GlobalFilterBar } from "./GlobalFilterBar";

interface Props {
  dateRange: DateRangeValue | null;
  onDateRangeChange: (value: DateRangeValue) => void;
  filters: Filters;
  onFiltersChange: (filters: Filters) => void;
}

export const TopBar: React.FC<Props> = ({ dateRange, onDateRangeChange, filters, onFiltersChange }) => {
  return (
    <Box sx={{ bgcolor: "#FFFFFF", flexShrink: 0, zIndex: 20, borderRadius: "8px", marginBottom: "16px" }}>
      {/* Filters + period/currency */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          p: "14px 20px 12px",
          flexWrap: "wrap"
        }}
      >
        <Typography sx={{ fontSize: "15px", lineHeight: "20px", color: "#071F35" }}>Filter:</Typography>
        <GlobalFilterBar filters={filters} onFiltersChange={onFiltersChange} />
        <Box sx={{ flex: 1 }} />
        <Box sx={{ "& .MuiButtonBase-root": { height: "26px", minHeight: "26px" } }}>
          <NumberFormat />
        </Box>
        <SelectDateRange
          formControlProps={{ sx: { minWidth: "200px" } }}
          selectProps={{
            startAdornment: <TodayOutlinedIcon sx={{ fontSize: "15px" }} />,
            sx: {
              "&.MuiInputBase-root": { height: "26px" },
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#DAE0E2" }
            }
          }}
          label=""
          value={dateRange}
          onChange={onDateRangeChange}
        />
        <Box sx={{ "& .MuiButtonBase-root": { height: "26px", minHeight: "26px" } }}>
          <SelectCurrency />
        </Box>
      </Box>
    </Box>
  );
};
